import React from 'react';
import { motion } from 'framer-motion';
import { Map, FileText, MessageSquare, Calendar, CheckCircle2 } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-brand-surface py-20 px-4 overflow-hidden" data-id="element-97">
      <div className="max-w-4xl mx-auto" data-id="element-98">
        {/* The Reveal */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-99">
          <span className="text-brand-yellow font-display font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-100">
            La Solución
          </span>
          <h2 className="font-display text-5xl md:text-6xl font-bold text-white mb-6" data-id="element-101">
            El Mapa 3×3
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-102">
            Este PDF está diseñado para una persona real: con vida real,
            cansancio real, y urgencia real.
          </p>
        </motion.div>

        {/* The Formula */}
        <div className="grid md:grid-cols-3 gap-4 mb-16 text-center" data-id="element-103">
          <div className="bg-[#111] p-6 rounded-lg border border-gray-800" data-id="element-104">
            <div className="text-4xl font-bold text-brand-yellow mb-2" data-id="element-105">3</div>
            <div className="text-gray-300 font-medium" data-id="element-106">
              Habilidades Normales
            </div>
            <div className="text-sm text-gray-500 mt-1" data-id="element-107">(Lo que ya sabes)</div>
          </div>
          <div className="flex items-center justify-center text-gray-600 font-display text-2xl" data-id="element-108">
            ×
          </div>
          <div className="bg-[#111] p-6 rounded-lg border border-gray-800" data-id="element-109">
            <div className="text-4xl font-bold text-brand-yellow mb-2" data-id="element-110">3</div>
            <div className="text-gray-300 font-medium" data-id="element-111">Plataformas Rápidas</div>
            <div className="text-sm text-gray-500 mt-1" data-id="element-112">
              (Donde compran hoy)
            </div>
          </div>
        </div>

        {/* What's Included */}
        <div className="bg-[#111] rounded-2xl p-8 md:p-12 border border-brand-yellow/20 shadow-[0_0_40px_rgba(0,0,0,0.5)]" data-id="element-113">
          <h3 className="font-display text-3xl font-bold text-white mb-8 text-center" data-id="element-114">
            Lo que recibes dentro del Libro Digital:
          </h3>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-115">
            <div className="space-y-6" data-id="element-116">
              <FeatureItem icon={<Map className="text-brand-yellow" data-id="element-118" />} title="El Método Mapa 3×3" desc="9 rutas listas (producto, servicio, digital simple). Tú eliges una." data-id="element-117" />
              <FeatureItem icon={<FileText className="text-brand-yellow" data-id="element-120" />} title="Plantillas de Publicación" desc="Título + descripción + fotos. Copiar y pegar." data-id="element-119" />
              <FeatureItem icon={<MessageSquare className="text-brand-yellow" data-id="element-122" />} title="Guiones de Venta" desc="Qué decir cuando preguntan precio, seguimiento y cierre." data-id="element-121" />
            </div>
            <div className="space-y-6" data-id="element-123">
              <FeatureItem icon={<Calendar className="text-brand-yellow" data-id="element-125" />} title="Plan Diario de 7 Días" desc="Paso a paso exacto. 30-60 minutos al día." data-id="element-124" />
              <FeatureItem icon={<CheckCircle2 className="text-brand-yellow" data-id="element-127" />} title="Manejo de Objeciones" desc="Respuestas para 'está caro', 'lo pienso', 'no confío'." data-id="element-126" />
              <FeatureItem icon={<CheckCircle2 className="text-brand-yellow" data-id="element-129" />} title="Rutina Semanal" desc="Cómo pasar de 1 venta a 5 ventas repitiendo el sistema." data-id="element-128" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function FeatureItem({
  icon,
  title,
  desc
}: {
  icon: React.ReactNode;
  title: string;
  desc: string;
}) {
  return <div className="flex gap-4" data-id="element-130">
      <div className="mt-1 p-2 bg-brand-yellow/10 rounded-lg h-fit" data-id="element-131">{icon}</div>
      <div data-id="element-132">
        <h4 className="font-bold text-white text-lg" data-id="element-133">{title}</h4>
        <p className="text-gray-400 text-sm leading-relaxed" data-id="element-134">{desc}</p>
      </div>
    </div>;
}